import axios from "./configAxios"
export const postGroupApi = async(requestData) => {
    return await axios.post(`/create/`, requestData)
}
// http://127.0.0.1:8000/api/erp/group/create/